var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('app-header'),_vm._v(" "),_c('app-left-menu'),_vm._v(" "),(_vm.isLoader)?_c('app-loader'):_c('main',[_c('transition',{attrs:{"name":"fade"}},[_c('keep-alive',{attrs:{"include":"user-list"}},[_c('router-view',{key:_vm.$route.path})],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }